import { AssetReport } from './AssetReport';
import { AssetSummary } from './AssetSummary';

const AssetDetails = () => (
  <AssetSummary>
    <AssetReport />
  </AssetSummary>
);

export { AssetDetails };
